module.exports = __webpack_public_path__ + "static/media/mashkorSignature.e1281a2e.jpg";